import { createBrowserRouter } from 'react-router';

import { RedirectIfAuthenticated, RequireAuth } from '@/auth/RequireAuth';
import { AppShell } from '@/components/AppShell';
import { NoEncontrado } from '@/components/NoEncontrado';
import { DirectorioPage } from '@/features/alumnos/DirectorioPage';
import { FichaPage } from '@/features/alumnos/FichaPage';
import { NuevoAlumnoPage } from '@/features/alumnos/NuevoAlumnoPage';
import { PorLicenciaPage } from '@/features/alumnos/PorLicenciaPage';
import { AuditoriaPage } from '@/features/auditoria/AuditoriaPage';
import { DefinirContrasenaPage } from '@/features/auth/DefinirContrasenaPage';
import { LoginPage } from '@/features/auth/LoginPage';
import { RecuperarPage } from '@/features/auth/RecuperarPage';
import { BibliotecaPage } from '@/features/contenido/BibliotecaPage';
import { ClasePage } from '@/features/contenido/clases/ClasePage';
import { ClasesPage } from '@/features/contenido/clases/ClasesPage';
import { EnarmPlusPage } from '@/features/contenido/enarmplus/EnarmPlusPage';
import { MatrizPage } from '@/features/contenido/MatrizPage';
import { TemarioPage } from '@/features/contenido/temario/TemarioPage';
import { ManualesPage } from '@/features/contenido/manuales/ManualesPage';
import { ManualPage } from '@/features/contenido/manuales/ManualPage';
import { PresentacionPage } from '@/features/contenido/presentaciones/PresentacionPage';
import { ResumenesPage } from '@/features/contenido/resumenes/ResumenesPage';
import { ResumenPage } from '@/features/contenido/resumenes/ResumenPage';
import { CuentaPage } from '@/features/cuenta/CuentaPage';
import { FechasEnarmPage } from '@/features/configuracion/FechasEnarmPage';
import { ProveedoresIaPage } from '@/features/configuracion/ProveedoresIaPage';
import { GenerarPage } from '@/features/ia/GenerarPage';
import { RevisionPage } from '@/features/ia/RevisionPage';
import { CatalogosPage } from '@/features/catalogos/CatalogosPage';
import { HerramientasPage } from '@/features/herramientas/HerramientasPage';
import { InicioPage } from '@/features/inicio/InicioPage';
import { EstadisticasPage } from '@/features/reportes/EstadisticasPage';
import { OpinionesPage } from '@/features/reportes/OpinionesPage';
import { SeguridadPage } from '@/features/reportes/SeguridadPage';
import { PagosPage } from '@/features/pagos/PagosPage';
import { BancoPage } from '@/features/preguntas/BancoPage';
import { ExamenesPage } from '@/features/preguntas/ExamenesPage';
import { ExamenPage } from '@/features/preguntas/ExamenPage';
import { PreguntaPage } from '@/features/preguntas/PreguntaPage';
import { ReportesPage } from '@/features/preguntas/ReportesPage';
import { ResueltosPage } from '@/features/preguntas/ResueltosPage';
import { BecasPage } from '@/features/tienda/BecasPage';
import { CuponesPage } from '@/features/tienda/CuponesPage';
import { EquiposPage } from '@/features/tienda/EquiposPage';
import { LicenciaPage } from '@/features/tienda/LicenciaPage';
import { LicenciasPage } from '@/features/tienda/LicenciasPage';
import { StaffFormPage } from '@/features/staff/StaffFormPage';
import { StaffListaPage } from '@/features/staff/StaffListaPage';

export const router = createBrowserRouter([
  {
    element: <RedirectIfAuthenticated />,
    children: [
      { path: '/login', element: <LoginPage /> },
      { path: '/recuperar', element: <RecuperarPage /> },
    ],
  },
  // El enlace del correo funciona con o sin sesión abierta.
  { path: '/definir-contrasena', element: <DefinirContrasenaPage /> },
  {
    element: <RequireAuth />,
    children: [
      {
        element: <AppShell />,
        children: [
          { index: true, element: <InicioPage /> },
          { path: 'cuenta', element: <CuentaPage /> },
          { path: 'alumnos', element: <DirectorioPage /> },
          { path: 'alumnos/nuevo', element: <NuevoAlumnoPage /> },
          { path: 'alumnos/por-licencia', element: <PorLicenciaPage /> },
          { path: 'alumnos/:id', element: <FichaPage /> },
          { path: 'tienda/licencias', element: <LicenciasPage /> },
          { path: 'tienda/licencias/:id', element: <LicenciaPage /> },
          { path: 'tienda/cupones', element: <CuponesPage /> },
          { path: 'tienda/becas', element: <BecasPage /> },
          { path: 'tienda/equipos', element: <EquiposPage /> },
          { path: 'pagos', element: <PagosPage /> },
          { path: 'contenido', element: <BibliotecaPage /> },
          { path: 'contenido/matriz', element: <MatrizPage /> },
          { path: 'contenido/clases', element: <ClasesPage /> },
          { path: 'contenido/enarm-plus', element: <EnarmPlusPage /> },
          { path: 'contenido/temario', element: <TemarioPage /> },
          { path: 'contenido/clases/:id', element: <ClasePage /> },
          { path: 'contenido/presentaciones/:id', element: <PresentacionPage /> },
          { path: 'contenido/manuales', element: <ManualesPage /> },
          { path: 'contenido/manuales/:id', element: <ManualPage /> },
          { path: 'contenido/resumenes-gpc', element: <ResumenesPage /> },
          { path: 'contenido/resumenes-gpc/:id', element: <ResumenPage /> },
          { path: 'preguntas', element: <BancoPage /> },
          { path: 'preguntas/examenes', element: <ExamenesPage /> },
          { path: 'preguntas/examenes/:id', element: <ExamenPage /> },
          { path: 'preguntas/reportes', element: <ReportesPage /> },
          { path: 'preguntas/resueltos', element: <ResueltosPage /> },
          { path: 'preguntas/:id', element: <PreguntaPage /> },
          { path: 'ia/generar', element: <GenerarPage /> },
          { path: 'ia/revision', element: <RevisionPage /> },
          { path: 'reportes', element: <EstadisticasPage /> },
          { path: 'reportes/opiniones', element: <OpinionesPage /> },
          { path: 'reportes/seguridad', element: <SeguridadPage /> },
          { path: 'configuracion/ia', element: <ProveedoresIaPage /> },
          { path: 'configuracion/catalogos', element: <CatalogosPage /> },
          { path: 'configuracion/herramientas', element: <HerramientasPage /> },
          { path: 'configuracion/fechas-enarm', element: <FechasEnarmPage /> },
          { path: 'staff', element: <StaffListaPage /> },
          { path: 'staff/auditoria', element: <AuditoriaPage /> },
          { path: 'staff/:id', element: <StaffFormPage /> },
          { path: '*', element: <NoEncontrado /> },
        ],
      },
    ],
  },
]);
